var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-2"},[_c('v-row',[_c('v-col',[_c('file-browser',{ref:"filebrowser",attrs:{"initialPath":_vm.initialPath,"mode":_vm.mode}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }